import { RiExternalLinkLine } from '@remixicon/react';

import { Link, Text } from '@backstage/ui';

import { AttachmentFragment } from '@spotify/confidence-graphql';
import { isSafeUrl } from '@spotify/plugin-confidence-artifacts-react';

import styles from './ExternalUrlArtifactContent.module.css';

interface ExternalUrlArtifactContentProps {
  artifact: AttachmentFragment;
  fallbackTitle?: (artifact: AttachmentFragment) => string;
}

const defaultFallbackTitle = (artifact: AttachmentFragment) => artifact.uri;

export const ExternalUrlArtifactContent = ({
  artifact,
  fallbackTitle = defaultFallbackTitle,
}: ExternalUrlArtifactContentProps) => {
  const label = artifact.displayName || fallbackTitle(artifact);
  const safe = isSafeUrl(artifact.uri);

  return (
    <div className={styles.info}>
      {safe ? (
        <Link
          href={artifact.uri}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
        >
          {label}
          <RiExternalLinkLine size={14} />
        </Link>
      ) : (
        <Text variant="body-medium">{label}</Text>
      )}
    </div>
  );
};
